import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import React, { createRef, useState } from 'react';
import cn from 'classnames';
import { useOnOutsideClick } from '@wix/da-hooks/pkg/useOnOutsideClick';
import PlusIcon from '@wix/da-ds/pkg/Icons/Plus';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import IconButton from '../../../Button/IconButton';
import ExternalToolbar from '../ExternalToolbar/ExternalToolbar';
import s from './SideToolbar.scss';
const SideToolbar = ({ className, style, toolbarProps })=>{
    const [isOpen, setIsOpen] = useState(false);
    const wrapperRef = /*#__PURE__*/ createRef();
    useOnOutsideClick(wrapperRef, ()=>{
        setIsOpen(false);
    });
    if (style.top) {
        style = _object_spread_props(_object_spread({}, style), {
            top: style.top - 4
        });
    }
    return /*#__PURE__*/ React.createElement("div", {
        ref: wrapperRef,
        className: cn(s['root'], className),
        style: style
    }, /*#__PURE__*/ React.createElement(IconButton, {
        className: cn(s['plus'], isOpen && s['plus-active']),
        onClick: ()=>setIsOpen(!isOpen)
    }, /*#__PURE__*/ React.createElement(PlusIcon, {
        size: IconSize.SMALL
    })), /*#__PURE__*/ React.createElement("div", {
        className: cn(s['toolbar-container'], isOpen && s['open'])
    }, isOpen && /*#__PURE__*/ React.createElement(ExternalToolbar, _object_spread_props(_object_spread({}, toolbarProps), {
        onPluginClick: ()=>setIsOpen(false)
    }))));
};
SideToolbar.displayName = 'SideToolbar';
export default SideToolbar;

//# sourceMappingURL=SideToolbar.js.map